export const sumByCategory = (items = []) =>
  items.reduce((total, item) => total + (item.amount || 0), 0);

export const groupByCategory = (items = []) => {
  const grouped = {};

  items.forEach((item) => {
    const category = item.category || "غير مصنف";

    if (!grouped[category]) {
      grouped[category] = { amount: 0, count: 0, items: [] };
    }

    grouped[category].amount += item.amount || 0;
    grouped[category].count += 1;
    grouped[category].items.push(item);
  });

  return grouped;
};

export const groupByType = (items = []) => {
  const grouped = {};

  items.forEach((item) => {
    const type = item.transaction_type || item.type || "غير معروف";

    if (!grouped[type]) {
      grouped[type] = { amount: 0, count: 0 };
    }

    grouped[type].amount += item.amount || 0;
    grouped[type].count += 1;
  });

  return grouped;
};

export const groupBySource = (items = []) => {
  const grouped = {};

  items.forEach((item) => {
    const source = item.source || item.account_name || "غير معروف";

    if (!grouped[source]) {
      grouped[source] = { amount: 0, count: 0 };
    }

    grouped[source].amount += item.amount || 0;
    grouped[source].count += 1;
  });

  return grouped;
};

export const sumCashFlowByCategory = (items = []) =>
  items.reduce((total, item) => total + (item.amount || item.cash_flow || 0), 0);

export const groupCashFlowByCategory = (items = []) => {
  const grouped = {};

  items.forEach((item) => {
    const category = item.category || item.type || "غير مصنف";

    if (!grouped[category]) {
      grouped[category] = { amount: 0, count: 0, items: [] };
    }

    grouped[category].amount += item.amount || item.cash_flow || 0;
    grouped[category].count += 1;
    grouped[category].items.push(item);
  });

  return grouped;
};

export const sumBalances = (items = []) =>
  items.reduce((total, item) => total + (item.balance || item.amount || 0), 0);
